<template>
  <div class="intent">
    <div class="intent__popup-blocker"
      v-if="showStatesPopup || !(showStatesParamsPopup === false) || showEntitiesPopup"
      @click="showEntitiesPopup = false; showStatesParamsPopup = false; showStatesPopup = false">
    </div>
    <div class="intent__btns">
      <btn
        v-if="!create"
        class="intent__del-section-button"
        icon="trash-alt"
        color="red"
        @click="deleteIntent"
      >{{ $t('btn.delete') }}</btn>
      <btn
        v-if="create"
        class="intent__basic-section-button"
        icon="save"
        @click="createNewIntent"
      >{{ $t('btn.create') }}</btn>
      <btn
        v-if="!create"
        class="intent__basic-section-button"
        icon="save"
        @click="saveEditedIntent"
      >{{ $t('btn.save') }}</btn>
    </div>
    <section-title>{{ intentTitle }}</section-title>
    <div class="intent__name-container">
      <section-title subsection>{{ $t('plugins.nlp.intent.basic') }}</section-title>
      <div class="intent__section editor-section">
        <!-- <div class="editor-section-description" v-if="!create">Change intent name.</div>
        <div class="editor-section-description" v-else>Specify intent name.</div> -->
        <div class="intent__basic-container">
          <in class="intent__input"
            v-model="intent.name"
            :label="$t('plugins.nlp.intent.name')"
            >
          </in>
          <sel class="intent__sel-block"
            :value="intent.block_uuid"
            :label="$t('plugins.nlp.intent.redirect')"
            @input="redirectIntentSelect($event)">
            <option :value="null">{{$t('plugins.nlp.intent.noRedirect')}}</option>
            <optgroup v-for="group in $store.state.flowGroups" :key="group.id" :label="group.name">
              <option
                v-for="block in group.blocks"
                :key="block.id"
                :value="block.uuid"
              >{{ block.name }}</option>
            </optgroup>
          </sel>
        </div>
        <d-slider 
          class="intent__conf" 
          label="confidence"
          :initPos="[Math.floor(intent.confidence_save*100), Math.floor(intent.confidence_detect*100)]"
          :steps="100"
          :colors="colorsForConf"
          @change="confidenceChange"
        />
      </div>
    </div>
    <div class="intent__phrases-container">
      <section-title subsection>{{$t('plugins.nlp.intent.phrases')}}</section-title>
      <div class="intent__section editor-section">
        <!-- <div class="editor-section-description">Add new or edit existing phrases.</div> -->
        <div class="intent__phrases-list">
          <in-phrase v-for="(item, index) in intent.training_phrases"
            class="intent__phrase"
            v-model="intent.training_phrases[index]"
            :class="[index === intent.training_phrases.length-1 ? 'intent__phrase-last' : '']"
            :entities="entities"
            :parameters="intent.parameters"
            :intentId="getIntentIdIfExists"
            :key="index"
            @del="deletePhrase(index)"
            @addNewTemplate="addNewPhraseTemplate(index)"
            >
          </in-phrase>
        </div>
      </div>
    </div>
    <div class="intent__parameters_container">
      <section-title subsection>{{ $t('plugins.nlp.intent.parameters') }}</section-title>
      <div class="intent__section editor-section">
        <!-- <div class="editor-section-description">Generated intent parameters.</div> -->
        <div class="intent__table-parameters">
          <div class="intent__table-header-cell">
            {{ $t('plugins.nlp.intent.parametersTable.name').charAt(0).toUpperCase() + $t('plugins.nlp.intent.parametersTable.name').slice(1)  }}
          </div>
          <div class="intent__table-header-cell">
            {{ $t('plugins.nlp.intent.parametersTable.entity').charAt(0).toUpperCase() + $t('plugins.nlp.intent.parametersTable.entity').slice(1) }}
          </div>
          <div class="intent__table-header-cell">
            {{ $t('plugins.nlp.intent.parametersTable.type').charAt(0).toUpperCase() + $t('plugins.nlp.intent.parametersTable.type').slice(1) }}
          </div>
          <div class="intent__table-header-cell">
            Del
          </div>
          <div class="intent__table-parameters-content">
            <div class="intent__table-parameters-content-cell intent__table-parameters-content-name"
              v-for="(param, index) in intent.parameters" :key="index+'name'">
              <div class="intent__table-parameters-item-name"
                :style="{ 'background': getParameterColor(param) }">
                {{ param.name }}
              </div>
            </div>
            <div class="intent__table-parameters-content-cell intent__table-parameters-content-entity"
              v-for="(param, index) in intent.parameters" :key="index+'entity'">
              {{ getParameterEntityName(param) }}
            </div>
            <div class="intent__table-parameters-content-cell intent__table-parameters-content-type"
              v-for="(param, index) in intent.parameters" :key="index+'type'">
              {{ getParameterType(param) }}
            </div>
            <div class="intent__table-parameters-content-cell intent__table-parameters-content-del"
              v-for="(param, index) in intent.parameters" :key="index+'del'">
              <fai icon="times" class="intent__table-parameters-del"
                @click="delParameter(index)"/>
            </div>
          </div>
        </div>
        <div class="intent__table-parameters-footer">
          <span class="intent__table-parameters-add"
            @click="showEntitiesPopup = true">
            Add new parameter
          </span>
        </div>
        <sel-popup ref="refEntitiesList"
          class="intent__entities-list intent__list"
          label="Entities"
          v-show="showEntitiesPopup"
          @close="showEntitiesPopup = false">
          <div class="intent__entities-list-groups">
            <div class="intent__entities-list-group">
              <div class="intent__entities-list-group-label">
                Text entities
              </div>
              <div class="intent__entities-list-content">
                <div class="intent__entities-list-item"
                  v-for="(entity, index) in getAvailableEntities.textEntities" :key="index"
                  @click="addNewParameter(entity)">
                  {{ entity.name }}
                </div>
                <div class="intent__entities-list-item--empty"
                  v-if="getAvailableEntities.textEntities.length === 0">
                  no entities
                </div>
              </div>
            </div>
            <div class="intent__entities-list-group">
              <div class="intent__entities-list-group-label">
                Regex entities
              </div>
              <div class="intent__entities-list-content">
                <div class="intent__entities-list-item"
                  v-for="(entity, index) in getAvailableEntities.regexEntities" :key="index"
                  @click="addNewParameter(entity)">
                  {{ entity.name }}
                </div>
                <div class="intent__entities-list-item--empty"
                  v-if="getAvailableEntities.regexEntities.length === 0">
                  no entities
                </div>
              </div>
            </div>
          </div>
        </sel-popup>
      </div>
    </div>
    <div class="intent__states-main-container">
      <section-title subsection>Limit states</section-title>
      <div class="intent__section editor-section">
        <div class="intent__states-main">
          <div class="intent__states-main-switches">
            <sw-button
              v-model="intent.states_limit_on"
              label="Enable limit"
              :inline="true"
            ></sw-button>
          </div>
          <div class="intent__states-main-cont">
            <div class="intent__states-main-item"
              :class="[ item.negate ? 'intent__states-main-item--excluded' : '']"
              v-for="(item, index) in intent.states"
              :key="index"
              @click="toggleStateNegation(item)"
              >
              <dynamic-text
                class="intent__states-main-item-text"
                :value="getStateById(item.states_id).name"
                :minWidth="30"
              />
              <fai icon="times" 
                class="intent__states-main-item-del"
                @click="deleteStateFromIntent(index)"/>
            </div>
            <fai icon="plus" class="intent__states-main-add-icon" 
              @click="showAddStatesMain($event)"/>
          </div>
          <sel-popup ref="refStatesList"
            class="intent__states-main-list intent__list"
            label="States"
            v-show="showStatesPopup"
            @close="showStatesPopup = false">
            <div class="intent__states-main-list-item intent__list-item"
              v-for="(item, index) in getAvailableStates(intent.states)" :key="index"
              @click="addNewStateToIntent(item)">
              {{ item.name }}
            </div>
            <div class="intent__states-main-list-item intent__list-item-empty"
              v-if="getAvailableStates(intent.states).length === 0">
              no states
            </div>
          </sel-popup>
        </div>
      </div>
    </div>
    <div class="intent__states-main-container">
      <section-title subsection>State transitions</section-title>
      <div class="intent__section editor-section">
        <sel-popup ref="refStatesParamsList"
          class="intent__states-params-list intent__list"
          label="Parameters"
          v-if="showStatesParamsPopup !== false"
          @close="showStatesParamsPopup = false">
          <div class="intent__states-params-list-item intent__list-item"
            @click="addNewParameterToStateTransition(showStatesParamsPopup, item)"
            v-for="(item, index) in getAvailableTransParameters(showStatesParamsPopup)" :key="index">
            {{ (item.parameter && item.parameter.name) || getParameterById(item.parameters_id).name  }}
          </div>
          <div class="intent__states-param-list-item intent__list-item-empty"
            v-if="getAvailableTransParameters(showStatesParamsPopup).length === 0">
            no states
          </div>
        </sel-popup>
        <sel-popup ref="refStatesTransList"
            class="intent__states-main-list intent__list"
            label="States"
            v-show="showStatesTransPopup"
            @close="showStatesTransPopup = false">
            <div class="intent__states-main-list-item intent__list-item"
              v-for="(item, index) in getAvailableStates(showStatesTransPopup ? showStatesTransPopup.states : [])" :key="index"
              @click="addNewStateToStateTransition(item, showStatesTransPopup)">
              {{ item.name }}
            </div>
            <div class="intent__states-main-list-item intent__list-item-empty"
              v-if="getAvailableStates(showStatesTransPopup ? showStatesTransPopup.states  : []).length === 0">
              no states
            </div>
        </sel-popup>
        <div class="intent__states-trans">
          <div class="intent__table-header-cell intent__table-header-cell--first">
            Entry state
          </div>
          <div class="intent__table-header-cell">
            Required parameters
          </div>
          <div class="intent__table-header-cell">
            Redirect
          </div>
          <div class="intent__table-header-cell">
            Del
          </div>
          <div class="intent__states-trans-content">
            <div class="intent__states-trans-entry intent__states-trans-content-cell"
              v-for="(trans, index) in intent.statesTransitions" :key="index+'entry'">
              <div class="intent__states-main-item intent__states-trans-entry-item"
                :class="[ item.negate ? 'intent__states-main-item--excluded' : '']"
                v-for="(item, index) in trans.states"
                :key="index+'entry'"
                @click="toggleStateNegation(item)"
                >
                <dynamic-text
                  class="intent__states-main-item-text"
                  :value="getStateById(item.states_id).name"
                  :minWidth="30"
                />
                <fai icon="times"
                  class="intent__states-main-item-del"
                  @click="deleteStateFromStateTransition(index, trans)"/>
              </div>
              <fai icon="plus" class="intent__states-trans-params-item-del" 
                @click="showAddStatesTrans($event, trans)"/>
            </div>

            <div class="intent__states-trans-params intent__states-trans-content-cell"
              v-for="(trans, index) in intent.statesTransitions" :key="index+'params'">
              <div class="intent__states-trans-params-item"
                v-for="(param, indexParam) in intent.statesTransitions[index].parameters" :key="indexParam+'params-item'"
                :style="{ 'background': param.parameter ? getParameterColor(param.parameter) 
                  : getParameterColor(getParameterById(param.parameters_id)) }">
                <div>{{ (param.parameter && param.parameter.name) || getParameterById(param.parameters_id).name  }}</div>
                <fai class="intent__states-trans-params-item-del" 
                  icon="times"
                  @click="delStateTransitionParameter(trans, indexParam)"/>
              </div>
              <fai icon="plus" 
                class="intent__states-trans-params-add"
                @click="showAddStatesParams(index)"/>
            </div>

            <div class="intent__states-trans-redirect intent__states-trans-content-cell"
              v-for="(trans, index) in intent.statesTransitions" :key="index+'redirect'">
              <sel class="intent__states-trans-sel"
                :value="trans.block_uuid"
                @input="redirectTransSelect(index, $event)">
                <option :value="null">no redirect</option>
                <optgroup v-for="group in $store.state.flowGroups" :key="group.id" :label="group.name">
                  <option
                    v-for="block in group.blocks"
                    :key="block.id"
                    :value="block.uuid"
                  >{{ block.name }}</option>
                </optgroup>
              </sel>
            </div>

            <div class="intent__states-trans-del intent__states-trans-content-cell"
              v-for="(trans, index) in intent.statesTransitions" :key="index+'del'">
              <fai icon="times"
                @click="delStateTransition(index)"/>
            </div>
          </div>
          <div class="intent__states-trans-footer">
            <span class="intent__states-trans-footer-add"
              @click="addNewStateTransition()">
              Add new transition
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import in_phrase from './Phrase.vue'
import d_slider from './DoubleSlider.vue'
import s_popup from './SelectPopup.vue'

import axios from "@/axios"
import store from '@/store'
export default {
  data () {
    return {
      showEntitiesPopup: false,
      showStatesPopup: false,
      showStatesParamsPopup: false,
      showStatesTransPopup: false,
      intent: {
        name: '',
        training_phrases: [{
          segments: []
        }],
        confidence_save: 0.6,
        confidence_detect: 0.8,
        states_limit_on: false,
        parameters: [],
        states: [],
        statesTransitions: []
      },
      toSave: {
        toDelete: []
      },
      parametersToSave: {
        toDelete: []
      },
      statesToSave: {
        toDelete: []
      },
      statesTransitionsToSave: {
        toDelete: []
      },
      statesTransitionsStatesToSave: {
        toDelete: []
      },
      statesTransitionsParametersToSave: {
        toDelete: []
      },

      colors: [
        '#9EC0FF',
        '#D1FFEE',
        '#FFD6E7',
        '#E8FFF0',
        '#B5DCFF'
      ], 
      activeParam: [],
      colorsForConf: [
        '#ff8080',
        '#ffb380',
        '#9fff80'
      ]
    }
  },
  
  props: {
    value: Object,
    entities: Object,
    create: Boolean,
    states: Array
  },

  watch: {
    value () {
      this.dataPrep()
    },
  },
  
  computed: {
    getIntentIdIfExists () {
      if(this.intent.id !== undefined) return this.intent.id
      else return
    },

    intentTitle () {
      if(this.create) return this.$t('plugins.nlp.intent.newTitle')
      return this.$t('plugins.nlp.intent.editTitle')
    },

    getAvailableEntities () {
      const isIn = (entity, params) => {
        for(let i = 0; i<params.length; i++) {
          if(entity.id === params[i].entities_id) return true
        }
        return false
      }
      if(!this.entities.textEntities || !this.entities.regexEntities) return {
        textEntities: [],
        regexEntities: []
      }
      const res = {
        textEntities: this.entities.textEntities.filter(item => { return !isIn(item, this.intent.parameters) }),
        regexEntities: this.entities.regexEntities.filter(item => { return !isIn(item, this.intent.parameters) })
      }
      return res
    }
  },

  mounted: function () {
    if(this.value) { 
      this.dataPrep()
    }
  },

  methods: {
    toggleStateNegation (item) {
      item.negate = !item.negate
      if(item.id !== undefined) item.edited = true
    },

    delStateTransitionParameter (stateTransition, index) {
      const param = stateTransition.parameters[index]
      if(param.id) {
        this.statesTransitionsParametersToSave.toDelete.push({
          id: param.id,
          parentId: stateTransition.id
        })
      }
      stateTransition.parameters.splice(index, 1)
    },

    delStateTransition (index) {
      const stateTransition = this.intent.statesTransitions[index]
      if(stateTransition.id) { 
        this.statesTransitionsToSave.toDelete.push(stateTransition.id)
        this.statesTransitionsParametersToSave.toDelete = this.statesTransitionsParametersToSave.toDelete.filter(item => {
          if(item.parentId === stateTransition.id) return false
          return true
        })
      }
      this.intent.statesTransitions.splice(index, 1)
    },

    addNewStateTransition () {
      const obj = {
        block_uuid: null,
        parameters: [],
        states: []
      }
      if(this.intent.id) obj.intents_id = this.intent.id
      this.intent.statesTransitions.push(obj)
    },

    getParameterById (id) {
      for(let i = 0; i<this.intent.parameters.length; i++) {
        if(this.intent.parameters[i].id === id) return this.intent.parameters[i]
      }
    },

    addNewParameterToStateTransition (index, param) {
      const stateTransition = this.intent.statesTransitions[index]
      stateTransition.parameters.push(param)
    },

    showAddStatesParams (index) {
      this.showStatesParamsPopup = index
    },

    getAvailableTransParameters () {
      if(this.showAddStatesParams === false) return []
      const trans = this.intent.statesTransitions[this.showStatesParamsPopup]
      const availableParams = []
      for(let i = 0; i<this.intent.parameters.length; i++) {
        let found = false
        for(let j = 0; j<trans.parameters.length; j++) {
          if((this.intent.parameters[i].id && this.intent.parameters[i].id === trans.parameters[j].parameters_id)
              || this.intent.parameters[i] === trans.parameters[j].parameter) {
            found = true
            break
          }
        }
        if(!found) {
          const transParameter = {}
          if(trans.id) transParameter.states_transitions_id = trans.id
          if(this.intent.parameters[i].id) transParameter.parameters_id = this.intent.parameters[i].id
          else {
            transParameter.parameter = this.intent.parameters[i]
          }
          availableParams.push(transParameter)
        }
      }
      return availableParams
    },

    redirectIntentSelect (uuid) {
      if(uuid === '') uuid = null
      this.intent.block_uuid = uuid
      this.$store.commit('SET_EDITED', true)
    },

    redirectTransSelect (index, uuid) {
      if(uuid === '') uuid = null
      const trans = this.intent.statesTransitions[index]
      trans.block_uuid = uuid
      if(trans.id) trans.edited = true
    },

    deleteStateFromIntent (index) {
      const state = this.intent.states[index]
      if(state.id) {
        this.statesToSave.toDelete.push(state.id)
      }
      this.intent.states.splice(index, 1)
    },

    deleteStateFromStateTransition (index, stateTransition) {
      const state = stateTransition.states[index]
      if(state.id) {
        this.statesTransitionsStatesToSave.toDelete.push(state.id)
      }
      stateTransition.states.splice(index, 1)
    },

    addNewStateToIntent (state) {
      const obj = {
        states_id: state.id,
        negate: false
      }
      if(this.intent.id !== undefined) obj.intents_id = this.intent.id
      this.intent.states.push(obj)
    },

    addNewStateToStateTransition (state, stateTransition) {
      const obj = {
        states_id: state.id,
        negate: false
      }
      if(stateTransition.id !== undefined) obj.states_transitions_id = stateTransition.id
      stateTransition.states.push(obj)
    },

    getAvailableStates (existingStates) {
      const availableStates = []

      for(let i = 0; i<this.states.length; i++) {
        const actState = this.states[i]
        let found = false
        for(let j = 0; j<existingStates.length; j++) {
          if(actState.id === existingStates[j].states_id) {
            found = true
            break
          }
        }
        if(!found) {
          availableStates.push(actState)
        }
      }

      return availableStates
    },

    showAddStatesMain (e) {
      const elem = this.$refs.refStatesList.$el
      this.showStatesPopup = true
    },

    showAddStatesTrans (e, stateTrans) {
      const elem = this.$refs.refStatesTransList.$el
      this.showStatesTransPopup = stateTrans
    },

    getStateById (id) {
      for(let i = 0; i<this.states.length; i++) {
        if(this.states[i].id === id) return this.states[i]
      }
    },

    delParameter (index) {
      const param = this.intent.parameters[index]
      // clean segments reference to parameter
      for(let i = 0; i<this.intent.training_phrases.length; i++) {
        const phrase = this.intent.training_phrases[i]
        for(let j = 0; j<phrase.segments.length; j++) {
          const segment = phrase.segments[j]
          if(segment.parameter && segment.parameter === param) { 
            delete segment.parameter
            phrase.edited = true
          }
        }
      }

      // clean transitions parameters
      for(let i = 0; i<this.intent.statesTransitions.length; i++) {
        const trans = this.intent.statesTransitions[i]
        for(let j = 0; j<trans.parameters.length; j++) {
          const transParam = trans.parameters[j]
          if((transParam.parameter && transParam.parameter === param) || transParam.parameters_id === param.id) {
            trans.parameters.splice(j, 1)
            j--
          }
        }
      }

      if(param.id) this.parametersToSave.toDelete.push(param.id)
      this.intent.parameters.splice(index, 1)
    },

    addNewParameter (entity) {
      const newParam = {
        name: entity.name,
        entities_id: entity.id,
        active: true
      }
      if(this.intent.id) newParam.intents_id = this.intent.id
      this.intent.parameters.push(newParam)
    },

    confidenceChange(newPos) {
      this.confPos = newPos
      this.intent.confidence_save = newPos[0]/100
      this.intent.confidence_detect = newPos[1]/100
      this.$store.commit('SET_EDITED', true)
    },

    validateIntent() {
      if(this.intent.name === '' || this.intent.training_phrases.length === 1) {
        this.notify('error', 'plugins.nlp.validation.intent.empty')
        return false
      }
      return true
    },

    dataPrep () {
      this.intent = JSON.parse(JSON.stringify(this.value))
      for(let i = 0; i<this.intent.training_phrases.length; i++) {
        this.setParametersReference(this.intent.training_phrases[i].segments)
      }
      let obj = {
        segments: []
      }
      if(this.intent.id !== undefined) obj.intents_id = this.intent.id
      this.intent.training_phrases.push(obj)
    },

    addNewPhraseTemplate (index) {
      if(index !== this.intent.training_phrases.length-1) return
      let obj = {
        segments: []
      }
      if(this.intent.id !== undefined) obj.intents_id = this.intent.id
      this.intent.training_phrases.push(obj)
    },

    deletePhrase (index) {
      let phrase = this.intent.training_phrases[index]
      if(phrase.id) {
        this.toSave.toDelete.push(phrase.id)
      }
      this.intent.training_phrases.splice(index, 1)
      this.$store.commit('SET_EDITED', true)
    },

    deleteIntent () {
      this.$emit('deleteIntent')
    },

    async createNewIntent () {
      try {
        if(!this.validateIntent()) return
        for(let i = 0; i<this.intent.training_phrases.length-1; i++) {
          this.replaceParameterReferenceWithIdOrIndex(this.intent.training_phrases[i].segments, this.intent.parameters)
        }
        let copyIntent = JSON.parse(JSON.stringify(this.intent))
        copyIntent.training_phrases.pop()
        this.replaceTransitionParameterReferenceWithIndex(copyIntent.statesTransitions, copyIntent.parameters)
        let res = await axios.post('/api/plugin/nlp/intents/create', {
          intent: copyIntent
        })
        this.fillCreatedIntentWithIds(copyIntent, res.data.idsTree)
        this.$emit('input', copyIntent)
        this.notify('success', 'plugins.nlp.success.intent.create')
        this.$store.commit('SET_EDITED', false)
      } catch(e) {
        this.notify('error', 'plugins.nlp.error.intent.create')
        console.error(e)
      }
    },

    fillCreatedIntentWithIds (intent, idsTree) {
      intent.id = idsTree.id
      // states
      for(let i = 0; i<intent.states.length; i++) {
        intent.states[i].id = idsTree.intentsStatesIds[i]
        intent.states[i].intents_id = intent.id
      }
      // parameters
      for(let i = 0; i<intent.parameters.length; i++) {
        intent.parameters[i].id = idsTree.parametersIds[i]
        intent.parameters[i].intents_id = intent.id
      }
      // phrases
      for(let i = 0; i<intent.training_phrases.length; i++) {
        let actPhrase = intent.training_phrases[i]
        let phraseIds = idsTree.training_phrasesIds[i]
        actPhrase.id = phraseIds.id
        actPhrase.intents_id = intent.id
        for(let j = 0; j<actPhrase.segments.length; j++) {
          actPhrase.segments[j].id = phraseIds.segmentsIds[j]
          if(actPhrase.segments[j].parameter_index !== undefined) {
            actPhrase.segments[j].parameters_id = intent.parameters[actPhrase.segments[j].parameter_index].id
            delete actPhrase.segments[j].parameter_index
          }
        }
      }
      // states
      for(let i = 0; i<intent.states.length; i++) {
        intent.states[i].id = idsTree.intentsStatesIds[i]
        intent.states[i].intents_id = intent.id
      }
      // statesTransitions 
      for(let i = 0; i<intent.statesTransitions.length; i++) {
        const transTree = idsTree.statesTransitionsIds[i]
        intent.statesTransitions[i].id = transTree.id
        intent.statesTransitions[i].intents_id = intent.id

        for(let j = 0; j<intent.statesTransitions[i].parameters.length; j++) {
          const actParam = intent.statesTransitions[i].parameters[j]
          actParam.id = transTree.parametersIds[j]
          actParam.states_transitions_id = transTree.id
          if(actParam.parameter_index !== undefined) {
            actParam.parameters_id = idsTree.parametersIds[actParam.parameter_index]
            delete actParam.parameter_index
          }
        }

        for(let j = 0; j<intent.statesTransitions[i].states.length; j++) {
          const actState = intent.statesTransitions[i].states[j]
          actState.id = transTree.statesIds[j]
          actState.states_transitions_id = transTree.id
        }
      }
    },

    async saveEditedIntent () {
      try {
        if(!this.validateIntent()) return
        for(let i = 0; i<this.intent.training_phrases.length-1; i++) {
          this.replaceParameterReferenceWithIdOrIndex(this.intent.training_phrases[i].segments, this.intent.parameters)
        }
        let copyIntent = JSON.parse(JSON.stringify(this.intent))
        copyIntent.training_phrases.pop()
        let dataToSave = this.buildUpdateDataToSave(copyIntent)
        let res = await axios.patch('/api/plugin/nlp/intents/update', {
          intents: [dataToSave]
        })
        this.statesTransitionsStatesToSave.toDelete = []
        this.statesTransitionsParametersToSave.toDelete = []
        this.parametersToSave.toDelete = []
        this.statesToSave.toDelete = []
        this.statesTransitionsToSave.toDelete = []
        this.fillEditedIntentWithIds(dataToSave, res.data.idsTrees[0])
        this.$emit('input', copyIntent)
        this.notify('success', 'plugins.nlp.success.intent.edit')
        this.$store.commit('SET_EDITED', false)
      } catch(e) {
        this.notify('error', 'plugins.nlp.error.intent.edit')
        console.error(e)
      }
    },

    fillEditedIntentWithIds (intentEdit, idsTree) {
      // intents states
      for(let i = 0; i<intentEdit.states.toCreate.length; i++) {
        intentEdit.states.toCreate[i].id = idsTree.intentsStatesIds[i]
      }
      // parameters
      for(let i = 0; i<intentEdit.parameters.toCreate.length; i++) {
        let actParameter = intentEdit.parameters.toCreate[i]
        intentEdit.parameters.toCreate[i].id = idsTree.parametersIds[i]
      }
      // training phrases - create
      for(let i = 0; i<intentEdit.training_phrases.toCreate.length; i++) {
        let actPhrase = intentEdit.training_phrases.toCreate[i]
        let phraseIds = idsTree.training_phrases.createdIds[i] 
        actPhrase.id = phraseIds.id
        for(let j = 0; j<actPhrase.segments.length; j++) {
          if(actPhrase.segments[j].parameter_index !== undefined) {
            actPhrase.segments[j].parameters_id = idsTree.parametersIds[actPhrase.segments[j].parameter_index]
            delete actPhrase.segments[j].parameter_index
          }
          actPhrase.segments[j].id = phraseIds.segmentsIds[j]
        }
      }
      // training phrases - edit
      for(let i = 0; i<intentEdit.training_phrases.toEdit.length; i++) {
        let actPhrase = intentEdit.training_phrases.toEdit[i]
        let segmentsIds = idsTree.training_phrases.editedIds[i]
        for(let j = 0; j<actPhrase.segments.length; j++) {
          if(actPhrase.segments[j].parameter_index !== undefined) {
            actPhrase.segments[j].parameters_id = idsTree.parametersIds[actPhrase.segments[j].parameter_index]
            delete actPhrase.segments[j].parameter_index
          }
          if(actPhrase.segments[j].id === undefined) {
            actPhrase.segments[j].id = segmentsIds.shift()
          }
        }
      }
      // states transitions 
      for(let i = 0; i<intentEdit.statesTransitions.toCreate.length; i++) {
        const transTree = idsTree.statesTransitionsIds[i]
        const actTrans = intentEdit.statesTransitions.toCreate[i]
        actTrans.id = transTree.id
        for(let j = 0; j<actTrans.parameters.length; j++) {
          const actParam = actTrans.parameters[j]
          actParam.id = transTree.parametersIds[j]
          actParam.states_transitions_id = transTree.id
          if(actParam.parameter_index !== undefined) {
            actParam.parameters_id = idsTree.parametersIds[actParam.parameter_index]
            delete actParam.parameter_index
          }
        }
        for(let j = 0; j<actTrans.states.length; j++) {
          const actState = actTrans.states[j]
          actState.id = transTree.statesIds[j]
          actState.states_transitions_id = transTree.id
        }
      }
      // states transitions - just parameters
      for(let i = 0; i<intentEdit.statesTransitionsParameters.toCreate.length; i++) {
        const actParam = intentEdit.statesTransitionsParameters.toCreate[i]
        actParam.id = idsTree.statesTransitionsParametersIds[i]
        if(actParam.parameter_index !== undefined) {
          actParam.parameters_id = idsTree.parametersIds[actParam.parameter_index]
          delete actParam.parameter_index
        }
      }

      // states transitions - just states
      for(let i = 0; i<intentEdit.statesTransitionsStates.toCreate.length; i++) {
        const actState = intentEdit.statesTransitionsStates.toCreate[i]
        actState.id = idsTree.statesTransitionsStatesIds[i]
      }
    },

    buildUpdateDataToSave (intent) {
      let editedIntent = {
        id: intent.id,
        name: intent.name,
        block_uuid: intent.block_uuid,
        confidence_save: intent.confidence_save,
        confidence_detect: intent.confidence_detect,
        states_limit_on: intent.states_limit_on,
        training_phrases: {
          toDelete: this.toSave.toDelete,
          toEdit: [],
          toCreate: []
        },
        parameters: {
          toDelete: this.parametersToSave.toDelete,
          toEdit: [],
          toCreate: []
        },
        states: {
          toDelete: this.statesToSave.toDelete,
          toCreate: [],
          toEdit: []
        },
        statesTransitions: {
          toDelete: this.statesTransitionsToSave.toDelete,
          toCreate: [],
          toEdit: []
        },
        statesTransitionsParameters: {
          toDelete: this.statesTransitionsParametersToSave.toDelete.map(item => item.id),
          toCreate: []
        },
        statesTransitionsStates: {
          toDelete: this.statesTransitionsStatesToSave.toDelete,
          toCreate: [],
          toEdit: []
        }
      }
      // intent fields
      if(this.value.name !== intent.name) editedIntent.name = intent.name
      // phrases
      for(let i = 0; i<intent.training_phrases.length; i++) {
        if (intent.training_phrases[i].id === undefined) {
          editedIntent.training_phrases.toCreate.push(intent.training_phrases[i])
        } else {
          if(intent.training_phrases[i].edited) {
            editedIntent.training_phrases.toEdit.push(intent.training_phrases[i])
            delete intent.training_phrases[i].edited
          }
        }
      }

      // parameters
      for(let i = 0; i<intent.parameters.length; i++) {
        const param = intent.parameters[i]
        if(!param.id) {
          editedIntent.parameters.toCreate.push(param)
        }
      }

      // states 
      for(let i = 0; i<intent.states.length; i++) {
        const state = intent.states[i]
        if(!state.id) {
          editedIntent.states.toCreate.push(state)
        } else {
          if(state.edited) { 
            editedIntent.states.toEdit.push(state)
            delete state.edited
          }
        }
      }

      this.replaceTransitionParameterReferenceWithIndex(intent.statesTransitions, editedIntent.parameters.toCreate)

      // statesTransitions
      for(let i = 0; i<intent.statesTransitions.length; i++) {
        const stateTrans = intent.statesTransitions[i];
        if(!stateTrans.id) {
          editedIntent.statesTransitions.toCreate.push(stateTrans)
        } else {
          if(stateTrans.edited) {
            editedIntent.statesTransitions.toEdit.push({
              id: stateTrans.id,
              block_uuid: stateTrans.block_uuid,
              intents_id: stateTrans.intents_id
            })
            delete stateTrans.edited
          }
          for(let j = 0; j<stateTrans.parameters.length; j++) {
            const param = stateTrans.parameters[j]
            if(!param.id) {
              editedIntent.statesTransitionsParameters.toCreate.push(param)
            }
          }

          for(let j = 0; j<stateTrans.states.length; j++) {
            const state = stateTrans.states[j]
            if(!state.id) {
              editedIntent.statesTransitionsStates.toCreate.push(state)
            } else {
              if(state.edited) {
                editedIntent.statesTransitionsStates.toEdit.push(state)
                delete state.edited
              }
            }
          }
        }
      }
      
      return editedIntent
    },

    replaceTransitionParameterReferenceWithIndex (statesTransitions, paramsToCreate) {
      for(let i = 0; i<statesTransitions.length; i++) {
        const stateTrans = statesTransitions[i];
        for(let j = 0; j<stateTrans.parameters.length; j++) {
          const param = stateTrans.parameters[j]
          if(!param.parameter) continue
          for(let k = 0; k<paramsToCreate.length; k++) {
            const mainParam = paramsToCreate[k]
            if(paramsToCreate[k].entities_id === param.parameter.entities_id) {
              param.parameter_index = k
              delete param.parameter
              break
            }
          }
        }
      }
    },
    
    replaceParameterReferenceWithIdOrIndex (segments, parameters) {
      for(let i = 0; i<segments.length; i++) {
        if(!segments[i].parameter) continue;
        // if parameter have id
        if(segments[i].parameter.id) {
          let id = segments[i].parameter.id
          segments[i].parameters_id = id
        } else { 
          // storing via order of not yet saved items in parameters array 
          let counter = 0
          for(let j = 0; j<parameters.length; j++) {
            if(parameters[j] == segments[i].parameter) {
              segments[i].parameter_index = counter
              break;
            }
            if(!parameters[j].id) counter++
          }
        }
        delete segments[i].parameter
      }
    },

    setParametersReference (segments) {
      for(let i = 0; i<segments.length; i++) {
        // if segment is binded to parameter
        if(segments[i].parameters_id !== undefined) {
          for(let j = 0; j<this.intent.parameters.length; j++) {
            // parameter found
            if(segments[i].parameters_id === this.intent.parameters[j].id) {
              // storing ref
              segments[i].parameter = this.intent.parameters[j]
              delete segments[i].parameters_id
            }
          }
        }
      }
    },
    
    getParameterColor (param) {
      for(let i = 0; i<this.intent.parameters.length; i++) {
        if(param === this.intent.parameters[i]) {
          return this.colors[i]
        }
      }
    },

    getParameterType (param) {
      for(let i = 0; i<this.entities.textEntities.length; i++) {
        if(this.entities.textEntities[i].id === param.entities_id) return 'text'
      }
      for(let i = 0; i<this.entities.regexEntities.length; i++) {
        if(this.entities.regexEntities[i].id === param.entities_id) return 'regex'
      }
    },

    getParameterEntityName (param) {
      for(let i = 0; i<this.entities.textEntities.length; i++) {
        if(this.entities.textEntities[i].id === param.entities_id) return this.entities.textEntities[i].name
      }
      for(let i = 0; i<this.entities.regexEntities.length; i++) {
        if(this.entities.regexEntities[i].id === param.entities_id) return this.entities.regexEntities[i].name
      }
    }
  },
  components: {
    'in-phrase': in_phrase,
    'd-slider': d_slider,
    'sel-popup': s_popup 
  }
}
</script>

<style lang="scss">
.intent {
  padding-left: 25px;
  padding-top: 6px;
  display: flex;
  flex-direction: column;
  max-height: 100%;

  &__popup-blocker {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 4000;
  }

  &__section {
    margin-bottom: 40px;
    position: relative;
    width: 50%;
    min-width: 540px;
  }

  &__input {
    width: 40%;
    margin-right: 40px;
  }

  &__phrase {
    margin-bottom: 10px;
  }

  &__phrase-last {
    margin-bottom: 0px;
  }

  &__btns {
    margin-top: 10px;
    margin-right: 10px;
    position: absolute;
    z-index: 3000;
    right: 0;
  }

  &__basic-container {
    display: flex;
  }

  &__conf {
    margin-top: 20px;
    width: 60%;
  }

  &__del-section-button {
    margin-right: 10px;
  }

  &__states-main-switches {
    display: flex;
    margin-bottom: 18px;
  }

  &__states-main-sw-wrapper {
    & .sw-button:nth-child(1) {
      background: $primary;
      &::before {
        background: $danger;
      }
    }
  }

  &__states-main-sw-excluded {
    margin-left: 28px;
  }

  &__states-main-cont {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
  }

  &__states-main-item {
    border: solid 1px $primary;
    border-radius: 2px;
    padding: 2px;
    background: white;
    display: flex;
    align-items: center;
    cursor: pointer;

    &--excluded {
      border-color: $danger;
    }
  }

  &__states-main-item-text {
    pointer-events: none;
  }

  &__states-main-item-del {
    color: $inactiveGrey;
    margin-top: 1px;
    margin-right: 4px;
    font-size: 0.8em;
    cursor: pointer;
  }

  &__states-main-add-icon {
    margin-bottom: 1px;
    padding: 2px;
    color: $inactiveGrey;
    font-size: 0.8em;
  }

  &__states-main-list-blocker {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  &__list {
    min-width: 200px;
    max-height: 200px;
    position: absolute;
    z-index: 5000;
    left: 0;
    top: 0;
  }

  &__list-item {
    padding: 8px 6px;
    cursor: pointer;

    &:nth-child(odd) {
      background: $bgLightGrey;
    }
  }

  &__list-item-empty {
    padding: 8px 6px;
    color: $inactiveGrey;
    font-style: italic;
    text-align: center;
  }

  &__states-trans {
    width: 100%;
    display: grid;
    grid-template-columns: 1.5fr 2fr 1fr 60px;
    grid-template-rows: min-content min-content min-content;
    grid-row-gap: 14px;
  }

  &__table-header-cell {
    border-bottom: solid 1px $inactiveGrey;
    font-weight: bold;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 6px;
    color: $inactiveGrey;
  }

  &__states-trans-content {
    grid-column-start: 1;
    grid-column-end: 5;
    display: grid;
    grid-template-columns: 1.5fr 2fr 1fr 60px;
    align-items: center;
    grid-row-gap: 14px;
    grid-auto-flow: column;
  }

  &__states-trans-content-cell {
    justify-content: center;
    align-items: center;
  }

  &__states-trans-entry {
    grid-column-start: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
  }

  &__states-trans-entry-item {
    padding: 2px;
  }

  &__states-trans-params {
    grid-column-start: 2;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    padding: 0px 4px;
  }

  &__states-trans-params-item {
    padding: 4px 6px;
    background: white;
    border-radius: 2px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__states-trans-params-item-del {
    font-size: 0.8em;
    opacity: 0.3;
  }

  &__states-trans-params-add {
    color: $inactiveGrey;
    margin-right: 2px;
    font-size: 0.8em;
    cursor: pointer;
  }

  &__states-trans-sel {
    grid-column-start: 3;
    width: 82%;
  }

  &__states-trans-redirect {
    grid-column-start: 3;
    display: flex;
    margin-top: -4px;
  }

  &__states-trans-del {
    grid-column-start: 4;
    display: flex;
    color: $inactiveGrey;
    cursor: pointer;
  }

  &__states-trans-footer {
    grid-column-start: 1;
    grid-column-end: 5;
  }

  &__states-trans-footer-add {
    @include clickableText()
  }

  &__table-parameters {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 100px;
    grid-template-rows: min-content 1fr min-content;
    grid-row-gap: 14px;
  }

  &__table-parameters-content {
    grid-column-start: 1;
    grid-column-end: 5;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 100px;
    justify-content: center;
    grid-auto-flow: column;
    grid-row-gap: 14px;
  }

  &__table-parameters-content-cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__table-parameters-content-name {
    grid-column-start: 1
  }

  &__table-parameters-item-name {
    padding: 2px 4px;
    border-radius: 2px;
  }

  &__table-parameters-content-del {
    cursor: pointer;
    color: $inactiveGrey;
  }

  &__table-parameters-footer {
    grid-row-start: 1;
    grid-row-end: 5;
    display: flex;
    justify-content: center;
  }

  &__table-parameters-add {
    @include clickableText()
  }

  &__entities-list-groups {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__entities-list-group-label {
    font-weight: bold;
    padding: 8px 0px;
  }

  &__entities-list-content > &__entities-list-item:nth-child(odd) {
    background: $bgLightGrey;
  }

  &__entities-list-item {
    padding: 8px 8px;
    cursor: pointer;

    &--empty {
      color: $inactiveGrey;
      background: white;
      text-align: center;
      font-style: italic; 
    }
  }
}
</style>